// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__23EOp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__19-q-","obliqueLine":"membershipbadge_obliqueLine__zWBWD"};